import AccessControl from "components/Systems/AccessControl/AccessControl";

export default AccessControl;
